import { render } from "./LoginTokenPage.vue?vue&type=template&id=08f97550"
import script from "./LoginTokenPage.vue?vue&type=script&lang=js"
export * from "./LoginTokenPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__